import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Button, Heading, Text } from '@components/common';

const TextWrapper = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  width: 104px;
  height: 48px;
  padding: 4px 8px;
  @media screen and (max-width: 767px) {
    width: 52px;
    justify-content: center;
    align-items: center;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const Row = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

function CycleHeader(props) {
  const { onModify, ...restProps } = props;

  const renderDesktopLayout = () => {
    return (
      <Box
        height={48}
        flexDirection="row"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        {...restProps}
      >
        <Heading px={2} py={0} my={0}>
          My Schedule
        </Heading>
        {onModify && (
          <Box>
            <Button variant="secondary" size="small" onClick={onModify}>
              Modify schedule
            </Button>
          </Box>
        )}
      </Box>
    );
  };

  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <Box>
      {renderDesktopLayout()}
      <Row>
        {days.map((day, index) => {
          const key = `calendar_days_${day}_${index}`;
          return (
            <TextWrapper key={key}>
              <Text fontSize={0}>{day}</Text>
            </TextWrapper>
          );
        })}
      </Row>
    </Box>
  );
}

CycleHeader.propTypes = {
  onModify: PropTypes.func
};

export default CycleHeader;
